import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OrderItemReportLine  {
    _originalTypeClassName = "ekylikeio.BO.OrderItemReportLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OrderItemReportLine.translate = translateService;
}
this.Quantity = null;
this.Date = null;
this.GroupKey = null;
this.FullGroupKey = null;
this.OrderItemReportLineKey = null;
this._key = this.OrderItemReportLineKey = 0; 
}

static translate: TranslateService;
_key: any;
Quantity:any;
Date:any;
GroupKey:any;
FullGroupKey:any;
Item:any;
SchoolBreak:any;
School:any;
private _OrderItemReportLineKey:any;
get OrderItemReportLineKey(): any {
    return this._OrderItemReportLineKey;
  }
set OrderItemReportLineKey(value: any) {
    this._OrderItemReportLineKey = value;
    this._key = value;
  }
static setItem = ($this, value) => {
var oldValue = $this.Item;
$this.Item = value;
if (value != null) {
}
}
static setSchoolBreak = ($this, value) => {
var oldValue = $this.SchoolBreak;
$this.SchoolBreak = value;
if (value != null) {
}
}
static setSchool = ($this, value) => {
var oldValue = $this.School;
$this.School = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OrderItemReportLineKey == null || $this.OrderItemReportLineKey == 0;
            }


}